
import { validateImageFile } from "@/utils/imageUtils";
import { validateImageContentEnhanced } from "@/utils/enhancedContentModeration";
import { useAuth } from "@/hooks/useAuth";
import { toast } from "@/hooks/use-toast";

export const usePhotoValidation = () => {
  const { user } = useAuth();

  const validateFile = async (file: File): Promise<boolean> => {
    const validationError = validateImageFile(file);
    
    if (validationError) {
      toast({
        title: "Invalid file",
        description: validationError,
        variant: "destructive",
      });
      return false;
    }
    return true;
  };

  const validateContent = async (file: File): Promise<boolean> => {
    if (!user) {
      toast({
        title: "Authentication required",
        description: "Please sign in to upload photos.",
        variant: "destructive",
      });
      return false;
    }

    try {
      const contentCheck = await validateImageContentEnhanced(file, user.id);
      
      if (!contentCheck.isAppropriate) {
        toast({
          title: "Content not allowed",
          description: contentCheck.reason || "This image cannot be uploaded. Please choose a different photo.",
          variant: "destructive",
        });
        return false;
      }
      return true;
    } catch (error) {
      console.error('Enhanced content validation error:', error);
      return true; // Allow upload if validation fails
    }
  };

  return {
    validateFile,
    validateContent
  };
};
